export const safeHtml = (content: string | null | undefined): string => {
  if (content === null || content === undefined) {
    return ''
  }

  return content
}
